import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

// Register necessary components for Chart.js
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const EmailCompaignMetrics = () => {
    const [timePeriod, setTimePeriod] = useState("Days"); // Default to 'Days'

    // Data for each time period (Days, Month, Year)
    const data = {
        labels: ["Compaign", "Compaign", "Compaign", "Compaign"],
        datasets: [
            {
                label: "Open Rate",
                data: [70, 70, 70, 70],
                backgroundColor: "#CB89B9",
                borderRadius: 30, // Apply circular corners to the bars
            },
            {
                label: "Click Through Rate",
                data: [45, 45, 45, 45],
                backgroundColor: "#728CC7",
                borderRadius: 30, // Apply circular corners to the bars
            },
            {
                label: "Conversion",
                data: [30, 30, 30, 30],
                backgroundColor: "#52279B",
                borderRadius: 30, // Apply circular corners to the bars
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    padding: 20,
                },
            },
            tooltip: {
                enabled: true, // ❌ Turn off tooltip if you also don't want hover values
            },
            datalabels: {
                display: false, // ⛔ Explicitly disable data labels if plugin is registered
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 20,
                },
            },
        },
    };


    return (

        <div className="campaign-chart-container">
            <div className="compaign-chart-wrapper">
                <Bar data={data} options={options} />
            </div>
        </div>

    );
};

export default EmailCompaignMetrics;
